import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SlateTextInput from "../../Shared/SlateTextInput";
import SlateSelect from "../../Shared/SlateSelect";
import { validation } from "../../../helpers/validationHelper";
import '../../SlateViewsSettings/style.css';

var listOfUnits = ['days', 'weeks', 'months', 'years'];
var listOfUnitsForOne = ['day', 'week', 'month', 'year'];

function getUnitOptions(amount) {
  var units = amount === 1 || amount === '1' ? listOfUnitsForOne : listOfUnits;
  return units.map(function(unit) {
    return { value: unit, text: unit.charAt(0).toUpperCase() + unit.slice(1) };
  });
}

var AlertItem = function(props) {
  var offsetAmount = props.offsetAmount;
  var offsetUnit = props.offsetUnit;
  var index = props.index;
  var deleteAlert = props.deleteAlert;
  var setOffsetAmount = props.setOffsetAmount;
  var setOffsetAmountError = props.setOffsetAmountError;
  var setOffsetUnit = props.setOffsetUnit;
  var dataErrors = props.dataErrors;

  var _useTranslation = useTranslation();
  var t = _useTranslation.t;

  var _useState = useState(offsetAmount === 1 || offsetAmount === '1' ? listOfUnitsForOne : listOfUnits);
  var setArrOfUnits = _useState[1];

  var _useState2 = useState(function() {
    if (offsetAmount === 1 || offsetAmount === '1') {
      return offsetUnit.endsWith('s') ? offsetUnit.slice(0, -1) : offsetUnit;
    }
    return offsetUnit;
  });
  var unit = _useState2[0];
  var setUnit = _useState2[1];

  var checkIsItSingularVersion = function() {
    var newUnit;
    if (offsetAmount.toString() !== '1') {
      newUnit = offsetUnit.endsWith('s') ? offsetUnit : offsetUnit + 's';
    } else {
      newUnit = offsetUnit.endsWith('s') ? offsetUnit.slice(0, -1) : offsetUnit;
    }
    if (newUnit !== unit) {
      setUnit(newUnit);
    }
  };

  useEffect(function() {
    var newArr = offsetAmount.toString() === '1' ? listOfUnitsForOne : listOfUnits;
    setArrOfUnits(newArr);
    checkIsItSingularVersion();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offsetAmount]);

  useEffect(function() {
    checkIsItSingularVersion();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offsetUnit]);

  var handleChange = function(e) {
    var value = e.target ? e.target.value : e.currentTarget.value;
    if (validation.isNumber(value) || value === '') {
      setOffsetAmount(value, index);
    }
  };

  var handleBlur = function() {
    if (offsetAmount === '' || offsetAmount === undefined) {
      setOffsetAmountError(
        t('notificationsPage:alertsCard:numberError') || 'Alert number must be greater than or equal to 0',
        index
      );
    }
  };

  var handleUnitChange = function(value) {
    setOffsetUnit(value, index);
  };

  var handleRemove = function(e) {
    deleteAlert(e, index);
  };

  var amountError = dataErrors['dateFieldReminderTrigger.alertOffsets[' + index + '].offsetAmount'] ||
                    dataErrors['alertOffsets[' + index + '].offsetAmount'];
  var unitError = dataErrors['dateFieldReminderTrigger.alertOffsets[' + index + '].offsetUnit'] ||
                  dataErrors['alertOffsets[' + index + '].offsetUnit'];

  var unitOptions = getUnitOptions(offsetAmount);

  return (
    <div className="settings-rule" key={index} data-index={index}>
      <div className="settings-rule-items-container">
        <div className="settings-rule-pattern-text" style={{flex: '0 0 auto', minWidth: 80, maxWidth: 100}}>
          <SlateTextInput
            name={'offsetAmount-' + index}
            value={offsetAmount !== undefined && offsetAmount !== null ? String(offsetAmount) : ''}
            onChange={handleChange}
            onBlur={handleBlur}
            error={amountError}
            placeholder={t('notificationsPage:alertsCard:number')}
          />
        </div>

        <div className="settings-rule-operator">
          <SlateSelect
            value={unit}
            options={unitOptions}
            onChange={handleUnitChange}
            placeholder={t('notificationsPage:alertsCard:period')}
            error={unitError}
          />
        </div>

        <span style={{color: '#374151', fontSize: 14}}>
          {t('notificationsPage:alertsCard:alertPart2')}
        </span>
      </div>

      <div className="settings-rule-btn-remove">
        <button
          type="button"
          className="settings-rule-remove-btn"
          onClick={handleRemove}
          aria-label={t('btn:remove')}
        >
          <i className="material-icons">close</i>
        </button>
      </div>
    </div>
  );
};

var AlertsList = function(props) {
  var deleteAlert = props.deleteAlert;
  var alertsList = props.alertsList;
  var setOffsetAmount = props.setOffsetAmount;
  var setOffsetAmountError = props.setOffsetAmountError;
  var setOffsetUnit = props.setOffsetUnit;
  var dataErrors = props.dataErrors;

  return (
    <div className="alerts-list">
      {alertsList.map(function(alert, index) {
        return (
          <AlertItem
            key={index}
            dataErrors={dataErrors}
            offsetAmount={alert.offsetAmount}
            offsetUnit={alert.offsetUnit}
            index={index}
            deleteAlert={deleteAlert}
            setOffsetAmount={setOffsetAmount}
            setOffsetUnit={setOffsetUnit}
            setOffsetAmountError={setOffsetAmountError}
          />
        );
      })}
    </div>
  );
};

export default AlertsList;
